import fullColorBlack from '../../logos/Full/Full - Color & Black.svg';
import glyphBlack from '../../logos/Glyph/Glyph - Black.svg';

/** Full wordmark + mark (color icon, black type) — headers and splash */
export const newrotuneLogoFullBlack = fullColorBlack;

/** Compact mark only — optional for tight spaces */
export const newrotuneGlyphBlack = glyphBlack;

/** @deprecated Prefer `newrotuneLogoFullBlack` */
export const newrotuneGlyphColor = fullColorBlack;
